import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-nav"
// Simple controller - nav stays fixed at bottom
export default class extends Controller {
  connect() {
    // Controller kept for potential future enhancements
    // Nav positioning handled purely by CSS
  }

  disconnect() {
    // No cleanup needed
  }
}
